import { isModifiedFromBackoffice, getModifiedPageData, getPageHtmlToSave } from './html';

export default {
	isModifiedFromBackoffice,
	getModifiedPageData,
	getPageHtmlToSave,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/htmlEditor/index.ts